import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { connect } from "react-redux";

import { BoxContainer } from "pro-features/pages/conversion/components/ConversionScatterChart/StyledComponents";
import CustomSegmentsAnalysis from "app/pages/segments/analysis/CustomSegmentsAnalysis";
import { SegmentsAnalysisContainer } from "pro-features/pages/segments/StyledComponents";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { ICustomSegment, ICustomSegmentAccount } from "app/services/segments/segmentsApiService";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

interface ISegmentsSingleAnalysisContainerProps {
    segments?: ICustomSegment[];
    organizationSegments?: ICustomSegmentAccount[];
    isLoading?: boolean;
}

const SegmentsSingleAnalysisContainer = (props: ISegmentsSingleAnalysisContainerProps) => {
    const { params } = useCurrentStateAndParams();
    const { organizationSegments } = props;
    const { id } = params;

    const currentSegment = useMemo(
        () => SegmentsUtils.getSegmentById({ segments: organizationSegments }, params?.id) as ICustomSegmentAccount,
        [organizationSegments, params?.id],
    );

    if (currentSegment && currentSegment.isLocked) {
        proNavigator.go("digitalsuite_segments-homepage");
        return null;
    }

    return (
        <SegmentsAnalysisContainer>
            <BoxContainer data-automation-sites-vs-category={true}>
                <CustomSegmentsAnalysis currentSegment={currentSegment} />
            </BoxContainer>
        </SegmentsAnalysisContainer>
    );
};

function mapStateToProps(store) {
    const {
        segmentsModule: { customSegmentsMeta, segmentsLoading },
    } = store;
    return {
        segments: customSegmentsMeta?.Segments,
        organizationSegments: customSegmentsMeta?.AccountSegments,
        isLoading: segmentsLoading,
    };
}

export default connect(mapStateToProps, undefined)(SegmentsSingleAnalysisContainer);
